import { render, staticRenderFns } from "./homeNotice.vue?vue&type=template&id=024adcf8&scoped=true"
import script from "./homeNotice.vue?vue&type=script&lang=js"
export * from "./homeNotice.vue?vue&type=script&lang=js"
import style0 from "./homeNotice.vue?vue&type=style&index=0&id=024adcf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024adcf8",
  null
  
)

export default component.exports